<template>
  <div id="news">
    <vice-title>
      <h3>{{ this.$t("lang.NewsInformation.name") }}</h3>
    </vice-title>
    <div id="new-list">
      <el-row :gutter="10">
        <el-col v-for="item of list" :key="item.id" :span="12"
          ><div class="case-item">
            <div @click="handleDetailClick(item.id)" class="case-left">
              <img :src="item.img" alt="" />
            </div>
            <div class="case-right">
              <h3 class="right-title">{{ item.title }}</h3>
              <p class="right-content">{{ item.abstract }}</p>
            </div>
          </div></el-col
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import ViceTitle from "../ViceTitle";
export default {
  name: "NewsList",
  components: {
    ViceTitle
  },
  data() {
    return {
      list: null
    };
  },
  mounted() {
    if (this.$i18n.locale === "en-US") {
      this.getList(1);
    } else if (this.$i18n.locale === "zh-CN") {
      this.getList(0);
    }
  },
  methods: {
    getList(type) {
      this.$http
       .post("http://api.chunhuahealth.com/api/news/list", {
        // .post("api/news/list", {
          type: type,
          is_news: 0
        })
        .then(res => {
          this.list = res.data.data.data;
          // this.tableData = res.data.data.data;
        })
        .catch();
    },
    handleDetailClick(id) {
      this.$router.push({
        path: "NewsDetail",
        query: {
          id: id
        }
      });
      console.log(id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#news {
  width: $width;
  margin: 0 auto;
  background: #ffffff;
  overflow: hidden;
  #new-list {
    width: 100%;
    min-width: 960px;
    margin: 60px auto;
    .case-item {
      margin-left: 10px;
      margin-bottom: 50px;
      display: flex;
      .case-left {
        height: 175px;
        width: 175px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .case-right {
        flex: 1;
        margin-top: 14px;
        margin-left: 20px;
        /*width: 300px;*/
        .right-title {
          color: #454545;
          font-size: 18px;
          margin-bottom: 20px;
          /*overflow: hidden;*/
          /*text-overflow: ellipsis;*/
          /*white-space: nowrap;*/
        }
        .right-content {
          color: #b2b2b2;
          font-size: 12px;
          line-height: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
